import React from "react";

// eslint-disable-next-line
function achievement_0() {
	return {
		date: "30 Jun 2024",
		title: "HKTDC Dragon Boat Team’s Victory in the Dragon Boat Short Course Races",
		description:
			"I am thrilled to be a part of the HKTDC dragon boat team and excited to share that we emerged as the Champion of the Mixed Boat Plate Final 🐲 ! This achievement truly highlights the power of teamwork, as our team displayed remarkable collaboration, skill, and dedication throughout the competition. It has been an incredible experience. 🔥",
		keywords: [
			"HKTDC dragon boat team",
			"Champions",
			"Teamwork",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 0</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.linkedin.com/feed/update/urn:li:activity:7213806220531388416/",
		linkText: "Checkout my LinkedIn post ",
	};
}

// eslint-disable-next-line
function achievement_1() {
	return {
		date: "10 Sep 2023",
		title: "Incredible experience as an OC member of the \"www.freedom Web-Accessibility\" event hosted by JCI Dragon",
		description:
			"This experience served as a reminder of the importance of promoting the popularization and application of the internet, and how it can bring greater convenience to citizens' lives. It was an honor to promote related work on web accessibility and cyber security, allowing more people to enjoy the convenience and safety brought by the internet.",
		keywords: [
			"Web-Accessibility",
			"Freedom",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 3</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.linkedin.com/feed/update/urn:li:activity:7056167757561659392/",
		linkText: "Checkout my LinkedIn post ",
	};
}

// eslint-disable-next-line
function achievement_2() {
	return {
		date: "10 Mar 2024",
		title: "Guest performer for my alma mater's 25th anniversary celebration",
		description:
			"I am truly honored to have been invited as a guest performer for my alma mater's 25th anniversary celebration. It's hard to believe how quickly time has passed, and I am filled with immense joy to have the opportunity to perform alongside the talented students I once taught.",
		keywords: [
			"Cello",
			"Performer",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 2</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.linkedin.com/feed/update/urn:li:activity:7172795874048196608/",
		linkText: "Checkout my LinkedIn post ",
	};
}

// eslint-disable-next-line
function achievement_3() {
	return {
		date: "17 Mar 2024",
		title: "AWS Certified Solutions Architect – Associate (SAA-C03) exam passed",
		description:
			"I’m happy to share that I’ve obtained a new certification: AWS Certified Solutions Architect – Associate from Amazon Web Services Training and Certification!",
		keywords: [
			"Cloud Computing",
			"AWS Certified Solutions Architect – Associate (SAA-C03)",
			"Amazon",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 1</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.credly.com/badges/74b525e2-424d-46ef-984f-e4c24ee09ab7",
		linkText: "Show credential ",
	};
}

// eslint-disable-next-line
function achievement_4() {
	return {
		date: "18 Oct 2024",
		title: "Farewell to HKTDC",
		description:
			"Time flies! After an incredible journey of 2+ years at Hong Kong Trade Development Council, I'm announcing my departure with a ❤️ full of gratitude. What started as a role of web developer has transformed me into a confident analyst programmer. I'm deeply thankful to my amazing colleagues who've become mentors and friends along the way. 🚀🌟",
		keywords: [
			"Farewell",
			"HKTDC",
			"Analyst Programmer",
			"Gratitude",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 4</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.linkedin.com/posts/sean-tsang_time-flies-after-an-incredible-journey-of-activity-7263022609707999233-CSd-",
		linkText: "Checkout my LinkedIn post ",
	};
}

function achievement_5() {
	return {
		date: "01 Nov 2024",
		title: "ServiceNow Certified System Administrator (CSA) exam passed",
		description:
			"I’m happy to share that I’ve obtained a new certification: ServiceNow Certified System Administrator from ServiceNow!",
		keywords: [
			"Cloud Computing",
			"ServiceNow Certified System Administrator (CSA)",
			"ServiceNow",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 5</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.credly.com/badges/beeaf740-e56a-4828-9c33-f9fc2f174b3b/public_url",
		linkText: "Show credential ",
	};
}

function achievement_6() {
	return {
		date: "18 Nov 2024",
		title: "Farewell to Cathay Pacific",
		description:
			"🌟Thank You, Cathay Pacific! 🌟 I want to take a moment to express my gratitude to Cathay Pacific for the opportunity to work as an Automation Developer. The culture at Cathay Pacific is truly brilliant, and I’ve had the pleasure of working alongside incredibly smart and helpful colleagues. A special shout-out to my lead, who has been incredibly supportive and always provided clear guidance. Your mentorship has made a significant impact on my experience. I was truly impressed by the use of up-to-date technology, which made my experience even more enriching. Although I’ve accepted a better offer elsewhere, I will definitely be looking for opportunities to return in the future. Thank you once again for everything! ✈️💼",
		keywords: [
			"Farewell",
			"Cathay Pacific",
			"Automation Developer",
			"Gratitude",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 6</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.linkedin.com/posts/sean-tsang_cathaypacific-automationdeveloper-activity-7272786064262492160-95R1",
		linkText: "Checkout my LinkedIn post ",
	};
}

function achievement_7() {
	return {
		date: "08 Mar 2025",
		title: "AWS Certified Machine Learning Engineer – Associate (MLA-C01) exam passed",
		description:
			"I’m happy to share that I’ve obtained a new certification: AWS Certified Machine Learning Engineer – Associate from Amazon Web Services (AWS)!",
		keywords: [
			"Cloud Computing",
			"AWS Certified Machine Learning Engineer – Associate (MLA-C01)",
			"Amazon Web Services (AWS)",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 5</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://www.credly.com/badges/beeaf740-e56a-4828-9c33-f9fc2f174b3b/public_url",
		linkText: "Show credential ",
	};
}

function achievement_8() {
	return {
		date: "01 Nov 2025",
		title: "Microsoft Certified: Azure AI Engineer Associate (AI-102) exam passed",
		description:
			"Just passed the AI-102 exam. I am grateful to SFC for providing excellent training opportunities that helped me prepare for this certification. I look forward to applying what I learned in AI to create more value for the team and contribute back to the company.",
		keywords: [
			"AI",
			"Azure AI",
			"AI-102",
			"Microsoft Certified: Azure AI Engineer Associate",
			"Professional Growth",
		],
		style: `
				.achievement-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="achievement-content">
					<div className="paragraph">Content of achievement 8</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
		link: "https://learn.microsoft.com/api/credentials/share/en-gb/Sean-8045/29787A09C47CD0A?sharingId=B93AB2F2BB0144A0",
		linkText: "Show certification ",
	};
}

const myachievements = [achievement_8, achievement_7, achievement_6, achievement_5, achievement_3];

export default myachievements;
